module.exports = {"350102001":"鼓东街道","350102002":"鼓西街道","350102003":"温泉街道","350102004":"东街街道","350102005":"南街街道","350102006":"安泰街道","350102007":"华大街道","350102008":"水部街道","350102009":"五凤街道","350102100":"洪山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350102.json
// module id = 1065
// module chunks = 0